import { ApiService } from "pwapi";

import { CaseAdminDetail } from "../../reducers/admin/adminCaseReducer";
import { SlideAdminWithUrls } from "../../reducers/admin/adminSlideReducer";
import { AsyncSagaAction, createAsyncSaga } from "../../utils/asyncActions";
import {
  ADMIN_SLIDE_BARCODE_REQUEST,
  ADMIN_SLIDE_MACRO_REQUEST,
  ADMIN_UPDATE_SLIDE_REQUEST,
  ADMIN_SLIDE_SET,
  ADMIN_DELETE_SLIDE_REQUEST,
  ADMIN_SLIDE_REQUEST,
  ADMIN_SLIDE_SUCCESS,
  ADMIN_SLIDE_FAILURE,
  ADMIN_CREATE_SLIDE_REQUEST,
  ADMIN_CREATE_SLIDE_SUCCESS,
  ADMIN_CREATE_SLIDE_FAILURE,
} from "../adminConstants";

export const getAdminSlide = createAsyncSaga(
  ADMIN_SLIDE_REQUEST,
  ADMIN_SLIDE_SUCCESS,
  ADMIN_SLIDE_FAILURE,
  (id: number) => `admin/slides/${id}`,
  (id: number) => ApiService.retrieveAdminSlide({ id })
) as AsyncSagaAction<number>;

type createSlideParams = Parameters<typeof ApiService.createAdminSlide>[0];

export const createAdminSlide = createAsyncSaga(
  ADMIN_CREATE_SLIDE_REQUEST,
  ADMIN_CREATE_SLIDE_SUCCESS,
  ADMIN_CREATE_SLIDE_FAILURE,
  () => "admin/slides/create",
  ApiService.createAdminSlide
) as AsyncSagaAction<createSlideParams>;

// Sets the current admin case for editing
export const setAdminSlide = (payload: SlideAdminWithUrls | null) => {
  return {
    type: ADMIN_SLIDE_SET,
    payload,
  };
};

export const updateAdminSlide = (payload: {
  slide: Partial<SlideAdminWithUrls>;
  case?: CaseAdminDetail;
  navigate?: any;
  returnUrl?: string;
}) => {
  return {
    type: ADMIN_UPDATE_SLIDE_REQUEST,
    payload,
  };
};

export const deleteAdminSlide = (payload: {
  case_id: number;
  slide_id: number;
  reason: string;
  navigate?: any;
  returnUrl?: string;
}) => {
  return {
    type: ADMIN_DELETE_SLIDE_REQUEST,
    payload,
  };
};

export const fetchBarcodeUrl = (slideId: number, caseId?: number) => {
  return {
    type: ADMIN_SLIDE_BARCODE_REQUEST,
    payload: {
      slideId: slideId,
      caseId: caseId,
    },
  };
};

export const fetchMacroUrl = (slideId: number, caseId?: number) => {
  return {
    type: ADMIN_SLIDE_MACRO_REQUEST,
    payload: {
      slideId: slideId,
      caseId: caseId,
    },
  };
};
